import {getEventId, hasCouponDiscount} from '@wix/wix-events-commons-statics'
import {isCouponInputVisible} from '../../../selectors/checkout-options'
import {getEvent} from '../../../selectors/event'
import {getInvoice, getInvoiceError, isValidating} from '../../../selectors/invoice'
import {isOrderCompleted} from '../../../selectors/placed-order'
import {getReservationId} from '../../../selectors/reservation'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {CouponInput as Presentation} from './coupon-input'
import {CouponInputOwnProps, CouponInputRuntimeProps} from './interfaces'

const mapRuntime = ({
  state,
  actions: {applyCoupon, removeCoupon, editStep},
}: DetailsPageAppProps): CouponInputRuntimeProps => {
  const placedOrder = state.placedOrder.order
  const event = getEvent(state)

  return {
    eventId: getEventId(event),
    error: getInvoiceError(state),
    reservationId: getReservationId(state),
    discountValid: hasCouponDiscount(getInvoice(state)),
    orderCompleted: isOrderCompleted(placedOrder),
    showCouponInput: isCouponInputVisible(state),
    applyCoupon,
    removeCoupon,
    validating: isValidating(state),
    editStep,
  }
}

export const CouponInput = connect<CouponInputOwnProps, CouponInputRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
